// src/theme/softwaholic.preset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// /**
//  * Prime preset that maps your Tailwind-driven CSS variables to Prime semantic tokens.
//  * When you change [data-brand] or [data-mode] on :root/html, the variables update
//  * and Prime components follow instantly (no rebuild).
//  */
// export const SoftwaholicPreset = definePreset(Aura, {
//   semantic: {
//     colorScheme: {
//       light: {
//         /* Brand / primary */
//         primary: {
//           color: 'rgb(var(--color-brand-600))',
//           contrastColor: 'rgb(var(--color-on-brand))',
//           hoverColor: 'rgb(var(--color-brand-700))',
//           activeColor: 'rgb(var(--color-brand-600))',
//         },

//         /* App surfaces & backgrounds */
//         surface: {
//           0: 'rgb(var(--color-surface-default))', // cards, sheets
//           50: 'rgb(var(--color-bg-default))',     // page chrome
//           900: 'rgb(17 24 39 / 1)'                // high-contrast ref
//         },

//         /* Text ramps */
//         text: {
//           color: 'rgb(var(--color-text-white))',
//           mutedColor: 'rgb(var(--color-text-muted-600))',
//           hoverColor: 'rgb(var(--color-text-muted-900))',
//           // optional aliases used by some components:

//           primaryColor: 'rgb(var(--color-text-muted-800))',
//           secondaryColor: 'rgb(var(--color-text-muted-700))',
//           inverseColor: 'rgb(255 255 255 / .92)'
//         },

//         /* Forms (applies to InputText, Dropdown, etc.) */
//         formField: {
//           background: 'rgb(var(--color-surface-default))',
//           color: 'rgb(var(--color-text-muted-800))',
//           placeholderColor: 'rgb(var(--color-text-muted-600))',
//           borderColor: 'rgb(0 0 0 / 0.08)',
//           hoverBorderColor: 'rgb(var(--color-brand-600))',
//           focusBorderColor: 'rgb(var(--color-brand-600))'
//         },

//         /* Focus ring (buttons, inputs, toggles) */
//         focusRing: {
//           width: '2px',
//           style: 'solid',
//           color: 'rgb(var(--color-brand-600))',
//           offset: '1px',
//         },

//         /* Status colors (success example; add warning/danger as needed) */
//         success: {
//           color: 'rgb(var(--color-success-500))',
//           contrastColor: 'rgb(255 255 255)',
//           hoverColor: 'rgb(var(--color-success-700))',
//           activeColor: 'rgb(var(--color-success-700))'
//         },

//         /* Shadow (used by some overlays) */
//         overlay: {
//           shadow: '0 10px 30px rgba(var(--color-shadow-rgb), 0.12)'
//         }
//       },

//       dark: {
//         primary: {
//           color: 'rgb(var(--color-brand-600))',
//           contrastColor: 'rgb(var(--color-on-brand))',
//           hoverColor: 'rgb(var(--color-brand-600))',
//           activeColor: 'rgb(var(--color-brand-600))'
//         },

//         surface: {
//           0: 'rgb(var(--color-surface-default))', // base cards
//           50: 'rgb(var(--color-bg-default))',     // app chrome
//           900: 'rgb(3 7 18 / 1)'
//         },

//         text: {
//           color: 'rgb(var(--color-text-muted-800))',       // light gray (your var points to gray-200)
//           mutedColor: 'rgb(var(--color-text-muted-600))',  // gray-400
//           hoverColor: 'rgb(var(--color-text-muted-900))',  // gray-100
//           secondaryColor: 'rgb(var(--color-text-muted-700))',
//           inverseColor: 'rgb(0 0 0 / .92)'
//         },

//         formField: {
//           background: 'rgb(var(--color-surface-default))',
//           color: 'rgb(var(--color-text-muted-800))',
//           placeholderColor: 'rgb(var(--color-text-muted-600))',
//           borderColor: 'rgb(255 255 255 / 0.06)',
//           hoverBorderColor: 'rgb(var(--color-brand-600))',
//           focusBorderColor: 'rgb(var(--color-brand-600))'
//         },

//         focusRing: {
//           width: '2px',
//           style: 'solid',
//           color: 'rgb(var(--color-brand-600))',
//           offset: '1px',
//         },

//         success: {
//           color: 'rgb(var(--color-success-500))',
//           contrastColor: 'rgb(255 255 255)',
//           hoverColor: 'rgb(var(--color-success-700))',
//           activeColor: 'rgb(var(--color-success-700))'
//         },

//         overlay: {
//           shadow: '0 10px 30px rgba(var(--color-shadow-rgb), 0.4)'
//         }
//       }
//     }
//   },

//   /**
//    * Component nudges (lightweight). Most styling should come from semantic tokens above.
//    * Only add things you truly need across the app.
//    */
//   components: {
//     button: {
//       // Use semantic tokens; keep radius/spacing from Aura
//       colorScheme: {
//         light: {
//           text: {
//             primary:{
//               hoverBackground: 'rgb(var(--color-brand-50))',
//               activeBackground: 'rgb(var(--color-brand-100))'

//             } 
//           }
//         },
//         dark: {
//           root: {

//           }
//         }
//       },
//       // Optional "success" utility class wired to your status tokens:
//       css: ({ dt }) => `
//         .p-button-success {
//           background: ${dt('success.color')};
//           color: ${dt('success.contrast.color')};
//         }
//         .p-button-success:hover {
//           background: ${dt('success.hover.color')};
//         }
//         .p-button-success:active {
//           background: ${dt('success.active.color')};
//         }
//       `
//  },

//     // card: {
//     //   colorScheme: {
//     //     light: {
//     //       root: { background: '{surface.0}', color: '{text.color}', borderColor: 'rgb(0 0 0 / 0.06)' },
//     //       subtitle: { color: '{text.muted.color}' }
//     //     },
//     //     dark: {
//     //       root: { background: '{surface.0}', color: '{text.color}', borderColor: 'rgb(255 255 255 / 0.06)' },
//     //       subtitle: { color: '{text.muted.color}' }
//     //     }
//     //   }
//     // },

//     // dialog: {
//     //   colorScheme: {
//     //     light: {
//     //       header: { background: '{surface.0}', color: '{text.color}' },
//     //       content: { background: '{surface.0}', color: '{text.color}' }
//     //     },
//     //     dark: {
//     //       header: { background: '{surface.0}', color: '{text.color}' },
//     //       content: { background: '{surface.0}', color: '{text.color}' }
//     //     }
//     //   },
//     //   overlay: {
//     //     shadow: '{overlay.shadow}'
//     //   }
//     // },

//     // Inputs (InputText, Dropdown, etc.) mainly rely on formField + focusRing above.
//   }
// });

export const SoftwaholicPreset = definePreset(Aura, {
  /* ──────────────────────────────────────────────
   * SEMANTIC TOKENS (wired to your CSS vars)
   * ──────────────────────────────────────────── */
  semantic: {
    /* Brand palette (exact hex from your vars) */
    // primary: {
    //   50:  '#f6f6fe',
    //   100: '#d5d3f9',
    //   200: '#b3aff4',
    //   300: '#928cef',
    //   400: '#7069ea',
    //   500: '#4f46e5',
    //   600: '#433cc3',
    //   700: '#3731a0',
    //   800: '#2b277e',
    //   900: '#201c5c',
    //   950: '#141239',
    // },

    // /* Focus ring (global) */
    // focusRing: {
    //   width:  'var(--p-focus-ring-width)',
    //   style:  'var(--p-focus-ring-style)',
    //   color:  'rgb(var(--p-focus-ring-color))',
    //   offset: 'var(--p-focus-ring-offset)',
    // },

    colorScheme: {
      /* LIGHT scheme */
      light: {
        /* Surfaces (point to your slate-driven surface ramp) */
        // surface: {
        //   0:   'rgb(var(--p-surface-0))',
        //   50:  'rgb(var(--p-surface-50))',
        //   100: 'rgb(var(--p-surface-100))',
        //   200: 'rgb(var(--p-surface-200))',
        //   300: 'rgb(var(--p-surface-300))',
        //   400: 'rgb(var(--p-surface-400))',
        //   500: 'rgb(var(--p-surface-500))',
        //   600: 'rgb(var(--p-surface-600))',
        //   700: 'rgb(var(--p-surface-700))',
        //   800: 'rgb(var(--p-surface-800))',
        //   900: 'rgb(var(--p-surface-900))',
        //   950: 'rgb(var(--p-surface-950))',
        // },

        /* Primary usage colors */
        primary: {
         // color:       'rgb(var(--p-primary-color))',
          // inverseColor:'rgb(var(--p-primary-contrast-color))',
          // hoverColor:  'rgb(var(--p-primary-hover-color))',
          // activeColor: 'rgb(var(--p-primary-active-color))',
        },

      //   /* Form Field semantics */
      //   formField: {
      //     background:              'rgb(var(--p-form-field-background))',
      //     hoverBackground:         'rgb(var(--p-form-field-filled-hover-background))',
      //     borderColor:             'rgb(var(--p-form-field-border-color))',
      //     hoverBorderColor:        'rgb(var(--p-form-field-hover-border-color))',
      //     focusBorderColor:        'rgb(var(--p-form-field-focus-border-color))',
      //     color:                   'rgb(var(--p-form-field-color))',
      //     placeholderColor:        'rgb(var(--p-form-field-placeholder-color))',
      //   },

      //   /* Highlights (selection) */
      //   highlight: {
      //     background:     'rgb(var(--p-highlight-background))',
      //     focusBackground:'rgb(var(--p-highlight-focus-background))',
      //     color:          'rgb(var(--p-highlight-color))',
      //     focusColor:     'rgb(var(--p-highlight-focus-color))',
      //   },
      // },

      // /* DARK scheme
      //    If you later define dark CSS vars, these will update automatically because we reference CSS custom props.
      //    For now we mirror the same tokens (safe default). */
      // dark: {
      //   surface: {
      //     0:   'rgb(var(--p-surface-0))',
      //     50:  'rgb(var(--p-surface-50))',
      //     100: 'rgb(var(--p-surface-100))',
      //     200: 'rgb(var(--p-surface-200))',
      //     300: 'rgb(var(--p-surface-300))',
      //     400: 'rgb(var(--p-surface-400))',
      //     500: 'rgb(var(--p-surface-500))',
      //     600: 'rgb(var(--p-surface-600))',
      //     700: 'rgb(var(--p-surface-700))',
      //     800: 'rgb(var(--p-surface-800))',
      //     900: 'rgb(var(--p-surface-900))',
      //     950: 'rgb(var(--p-surface-950))',
      //   },
      //   primary: {
      //     color:       'rgb(var(--p-primary-color))',
      //     inverseColor:'rgb(var(--p-primary-contrast-color))',
      //     hoverColor:  'rgb(var(--p-primary-hover-color))',
      //     activeColor: 'rgb(var(--p-primary-active-color))',
      //   },
      //   formField: {
      //     background:              'rgb(var(--p-form-field-background))',
      //     hoverBackground:         'rgb(var(--p-form-field-filled-hover-background))',
      //     borderColor:             'rgb(var(--p-form-field-border-color))',
      //     hoverBorderColor:        'rgb(var(--p-form-field-hover-border-color))',
      //     focusBorderColor:        'rgb(var(--p-form-field-focus-border-color))',
      //     color:                   'rgb(var(--p-form-field-color))',
      //     placeholderColor:        'rgb(var(--p-form-field-placeholder-color))',
      //   },
      //   highlight: {
      //     background:     'rgb(var(--p-highlight-background))',
      //     focusBackground:'rgb(var(--p-highlight-focus-background))',
      //     color:          'rgb(var(--p-highlight-color))',
      //     focusColor:     'rgb(var(--p-highlight-focus-color))',
      //   },
      },
    },
  },

  /* ──────────────────────────────────────────────
   * COMPONENT TOKENS → BUTTON (complete + wired)
   * ──────────────────────────────────────────── */
  components: {
      datatable: {
        header:{
            padding: 'var(--p-datatable-header-sm-padding)',
        },

      },

      // /* Size / layout (scheme-agnostic) */
      // root: {
      //   borderRadius:          'var(--p-button-border-radius)',
      //   roundedBorderRadius:   'var(--p-button-rounded-border-radius)',
      //   gap:                   'var(--p-button-gap)',
      //   paddingX:              'var(--p-button-padding-x)',
      //   paddingY:              'var(--p-button-padding-y)',
      //   iconOnlyWidth:         'var(--p-button-icon-only-width)',
      //   raisedShadow:          'var(--p-button-raised-shadow)',
      //   badgeSize:             'var(--p-button-badge-size)',
      //   transitionDuration:    'var(--p-button-transition-duration)',
      //   focusRing: {
      //     width:  'var(--p-button-focus-ring-width)',
      //     style:  'var(--p-button-focus-ring-style)',
      //     offset: 'var(--p-button-focus-ring-offset)',
      //   },
      //   label: {
      //     fontWeight: 'var(--p-button-label-font-weight)',
      //   },
      //   lg: {
      //     fontSize:       'var(--p-button-lg-font-size)',
      //     paddingX:       'var(--p-button-lg-padding-x)',
      //     paddingY:       'var(--p-button-lg-padding-y)',
      //     iconOnlyWidth:  'var(--p-button-lg-icon-only-width)',
      //   },
      //   sm: {
      //     fontSize:       'var(--p-button-sm-font-size)',
      //     paddingX:       'var(--p-button-sm-padding-x)',
      //     paddingY:       'var(--p-button-sm-padding-y)',
      //     iconOnlyWidth:  'var(--p-button-sm-icon-only-width)',
      //   },
      // },

}
});
